import axios from '@/libs/api.request'

//添加分类
export const addHelperCategory = async (data) => {

    return axios.request({
        url: '/shop/helper/addHelperCategory',
        data,
        method: 'post'
    })

}
//获取所有的分类
export const getAllHelperCategory = async (data) => {

    return axios.request({
        url: '/shop/helper/getAllHelperCategory',
        data,
        method: 'post'
    })
    
}
//添加问题描述
export const addHelperCategoryDescription = (data) => {
    return axios.request({
        url: '/shop/helper/addHelperCategoryDescription',
        data,
        method: 'post'
    })
}
//获取分类下的所有问题
export const getQuestionByCategory = (data) => {
    return axios.request({
        url: '/shop/helper/getAllQuestionUnderCategory',
        data,
        method: 'post'
    })
}
//getQuestionByCategory

export const deleteFaqCategory = async (that, data) => {
    var res = await axios.request({
        url: '/shop/helper/deleteFaqCategory',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const deleteFaq = async (that, data) => {
    var res = await axios.request({
        url: '/shop/helper/deleteFaq',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

